// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  
  urlCampania: 'https://api.implementos2.com.pe/api/campaniaCorp',
  urlCms: 'https://api.implementos2.com.pe/api/v1/cms',
  // urlCms: 'http://localhost:3700/api/v1/cms',
  urlLogin: 'https://api.implementos2.com.pe/api/peru',
  urlCatalogo: 'https://api.implementos2.com.pe/api/catalogo',
  apiElastic: 'https://b2b-api.implementos.cl/api/articulo/',
  urlSeguridad: 'https://api.implementos2.com.pe/api/peru',
  urlOms: 'https://dev-api.implementos.cl/api/oms', //por unas tablas excel,
  base_url_imagen: 'https://api.implementos2.com.pe/images', //para los iconos cyber
  PAIS: 'PE',


  urlLogistica: 'https://api.implementos2.com.pe/api/logistica',  // una tabla rara
  urlCliente: 'https://b2b-api.implementos.cl/api/cliente', // revisar bien

};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
